import React from "react";
import {useCsContext} from "../../state/CsInstance";
import {observer} from "mobx-react-lite";

import styles from "./Editor.module.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/sharp-regular-svg-icons/faPlus";
import AddActorModalContent from "../Modals/AddActorModalContent";
import FileTab from "./FileTab";

/**
 * Renders the tabs and dividers for the open files.
 */
const FileTabContainer: React.FC = () => {
	const {codeStore, globalModalStore} = useCsContext();

	/**
	 * @returns An array of tab elements and dividers
	 */
	const renderTabs = () => {
		const filesOpen = codeStore.filesOpen.filter((f) => !!f);
		let tabs = filesOpen
			.map((filename) => {
				return <FileTab key={filename} filename={filename} />;
			})
			.filter((tab) => !!tab);

		// Limit the number of tabs to 10
		tabs = tabs.splice(0, 10);

		tabs.push(
			<button
				key={"newFile"}
				id={"newFileButton"}
				className={[styles.tabButtonWrapper, styles.newFileTab].join(" ")}
				onClick={() => globalModalStore.showModal(<AddActorModalContent />)}
				aria-label="Create New File"
			>
				<FontAwesomeIcon icon={faPlus} className={styles.icon} />
			</button>
		);

		const focusedIndex = filesOpen.findIndex(
			(f) => f === codeStore.focusedFile
		);

		const tabsAndDividers = tabs.map((tab, i) => {
			// add dividers after every element, except for the element before the focused element and the
			// focused element
			if (
				i === focusedIndex ||
				i === focusedIndex - 1 ||
				i === tabs.length - 1
			) {
				return [tab, <div className={styles.hiddenTabDivider} key={i} />];
			}
			return [tab, <div className={styles.tabDivider} key={i} />];
		});

		return tabsAndDividers.flat();
	};

	return (
		<div id="fileTabContainer" className={styles.fileTabContainer}>
			{renderTabs()}
		</div>
	);
};

export default observer(FileTabContainer);
